import TeacherColumn from "./TeacherColumn";
import { connect } from "react-redux";

import {
  selectCurrentDlsCategory,
  selectMaterialsByCategoryAndTabSorted
} from "~/store/selectors/dls";
import { showModal } from "~/store/ducks/domain/ui/modal";
import { selectIsPresentationActive } from "~/store/ducks/user/uistate";
import {
  addPresentationMarker,
  updatePresentationMarker
} from "~/store/ducks/user/presentationMarkers";
import { setShapeType, setDrawingMode } from "~/store/ducks/application/fabric";

const mapStateToProps = state => ({
  category: selectCurrentDlsCategory(state),
  materials: selectMaterialsByCategoryAndTabSorted(state),
  isPresentationMode: selectIsPresentationActive(state)
});

const mapDispatchToProps = dispatch => ({
  openViewerModal: props => {
    dispatch(setDrawingMode(false));
    dispatch(setShapeType(null));
    dispatch(showModal("VIEWER", props));
  },
  openMaterialRendererModal: props => {
    dispatch(showModal("MATERIAL_RENDERER", props));
  },
  openNewDlsUserMaterialModal: event => {
    dispatch(showModal("DLS_USER_MATERIAL_NEW"));
  },
  openShowDlsUserMaterialModal: material => event => {
    event.stopPropagation();
    dispatch(showModal("DLS_USER_MATERIAL_SHOW", { material }));
  },
  showModal: (kind, props) => {
    dispatch(showModal(kind, props));
  },
  addPresentationMarker: marker => {
    dispatch(addPresentationMarker(marker));
  },
  updatePresentationMarker: marker => {
    dispatch(updatePresentationMarker(marker));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(TeacherColumn);
